<template lang="pug">
v-container.py-8.pl-4
  template(v-if="isFetching && !fetchingData")
    v-row(no-gutters)
      v-col
        v-skeleton-loader(type="article")
      v-col
        v-skeleton-loader(type="image")
  template(v-else)
    review-page-setup(:fetchingData="fetchingData")
    v-divider.mt-4.mb-10
    email-setup(:fetchingData="fetchingData")
    v-divider.mt-4.mb-10
    sms-whatsapp-template-setup(:fetchingData="fetchingData" :os="os")
    v-divider.mt-4.mb-10
    google-business-page-setup(:fetchingData="fetchingData" :gmbAccountName="gmbAccountName" hasConnected showDescription @reconnect="$emit('googlePageSetup')")
</template>

<script>
import { mapGetters } from 'vuex'
import ReviewPageSetup from '@/components/review/settings/ReviewPageSetup.vue'
import EmailSetup from '@/components/review/settings/EmailSetup.vue'
import SmsWhatsappTemplateSetup from '@/components/review/settings/SmsWhatsappTemplateSetup.vue'
import GoogleBusinessPageSetup from '@/components/review/settings/GoogleBusinessPageSetup.vue'

export default {
  name: 'ReviewPageTab',
  components: {
    ReviewPageSetup,
    EmailSetup,
    SmsWhatsappTemplateSetup,
    GoogleBusinessPageSetup
  },
  props: {
    isFetching: {
      type: Boolean,
    },
    fetchingData: {
      type: Object,
      default: null,
    },
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  computed: {
    ...mapGetters({
      reviewAccount: 'review/getMainAccount',
    }),
    gmbAccountName() {
      return this.reviewAccount.account_name
    },
  }
}
</script>

<style scoped>
</style>